import React from 'react';
import { useResizeDetector } from 'react-resize-detector';

export interface ResizeDetectorWrapperProps {
  children({ width }: { width: number }): React.ReactNode;
  className?: string;
  dataHook?: string;
}

export function ResizeDetectorWrapper({
  children,
  className,
  dataHook,
}: ResizeDetectorWrapperProps) {
  const { width, ref } = useResizeDetector();

  return (
    // TODO: replace this dummy width
    <div className={className} ref={ref} data-hook={dataHook}>
      {children({ width: width ?? 300 })}
    </div>
  );
}
